import { Button } from "@/components/ui/button";
import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import { useCampaignNavigation } from "routes/campaign/useCampaignNavigation";

const CREATE_ACLS = [
  ACL_RELATIONSHIPS.campaign.create,
  ACL_RELATIONSHIPS.campaignStatusPreset.read,
];

/** The Campaigns table's create action. */
const NewCampaignButton = () => {
  const { openCreate } = useCampaignNavigation();

  return (
    <Authorized permissions={CREATE_ACLS}>
      <Button size="sm" className="item-adder" onClick={openCreate}>
        New Campaign
      </Button>
    </Authorized>
  );
};

export default NewCampaignButton;
